import axios, { InternalAxiosRequestConfig } from 'axios';

const axiosClient = axios.create();

axiosClient.interceptors.request.use((requestConfig: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('token');
  requestConfig.headers.set('Authorization', `Bearer ${token}`);
  return requestConfig;
});

export default axiosClient;
